<template lang="pug">
  .landingpage.page-left-right.grid(:class="[ grid, { 'page-enter-active page-enter': enter }, { 'page-leave-active page-leave-to': leave } ]")
    .col.left-area
      affix.sticky-stuff(
        ref="left"
        relative-element-selector=".scroll-area"
        :enabled="sticky"
        :scroll-affix="true"
        :offset="{ top: 0, bottom: 0 }"
      )
        slot(name="header")
        main(v-if="left.length")
          section(
            v-for="(section, index) in left"
            :key="section.id"
            :class="section.key"
          )
            Heading(v-if="section.key === 'heading'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            LoginForm(v-if="section.key === 'login'" :section="section")
            //- Banner(v-if="section.key === 'banner'" :section="section")
            Slider(v-if="section.key === 'slider'" :section="section")
            PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section")
    .scroll-area(ref="scroll")
    .col.right-area(v-if="right.length")
      affix.sticky-stuff(
        ref="right"
        relative-element-selector=".scroll-area"
        :enabled="sticky"
        :scroll-affix="true"
        :offset="{ top: 0, bottom: 0 }"
      )
        section(
          v-for="(section, index) in right"
          :key="section.id"
          :class="section.key"
        )
          Post(v-if="section.key === 'post'" :section="section")
          ImageSection(v-if="section.key === 'image'" :section="section")
          PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section")
    slot(name="footer")
</template>

<script>
import { mapGetters } from 'vuex';

import Page from '@/views/Page';

import Heading from '@/components/Heading';
import ImageSection from '@/components/ImageSection';
import Post from '@/components/Post';
import Slider from '@/components/Slider';
import PhotoAlbum from '@/components/PhotoAlbum';
// import CategoryPosts from '@/components/CategoryPosts'
// import SocialWall from '@/components/SocialWall'
// import Banner from '@/components/Banner';

import LoginForm from '@/extensions/restricted-area/components/LoginForm';

export default {
    name: 'ContentPage',
    extends: Page,
    data: () => ({
        sticky: undefined,
        leave: false,
        enter: true
    }),
    components: {
        Heading,
        ImageSection,
        Post,
        Slider,
        PhotoAlbum,
        // CategoryPosts,
        // SocialWall,
        // Banner
        LoginForm
    },
    computed: {
        left() {
            let sections = [];
            if (this.areas.left && this.areas.left.length) {
                const supported = ['heading', 'photoalbum', 'post', 'login', 'slider'];
                sections = this.areas.left.filter(el => supported.includes(el.key));
            }
            return sections;
        },
        right() {
            let sections = [];
            if (this.areas.right && this.areas.right.length) {
                const supported = ['image', 'photoalbum', 'post'];
                sections = this.areas.right.filter(el => supported.includes(el.key));
            }
            return sections;
        },
        grid() {
            let grid = 'col-1';
            if (this.left.length && this.right.length) {
                grid = 'col-2';
            }
            return grid;
        },
        ...mapGetters({
            tailwind: 'tailwind'
        })
    },
    mounted() {
        const breakpoint = parseInt(this.tailwind.theme.screens.lg);
        this.sticky = window.innerWidth >= breakpoint;

        // const fixStickyStuff = () => {
        //   if (this.sticky && this.$refs.left && this.$refs.right && this.$refs.scroll) {
        //     const leftHeight = this.$refs.left.$el.clientHeight;
        //     const rightHeight = this.$refs.right.$el.clientHeight;
        //     const fullHeight = this.$refs.scroll.clientHeight;

        //     // if left area is smaller than full height
        //     // and full height is larger than viewport
        //     // make it sticky
        //     if (leftHeight < fullHeight && fullHeight > window.innerHeight) {
        //       console.log('left stick');
        //       this.$refs.left.stick();
        //     } else {
        //       console.log('left unstick');
        //       this.$refs.left.unstick();
        //     }

        //     // if right area is smaller than full height
        //     // and full height is larger than viewport
        //     // make it sticky
        //     if (rightHeight < fullHeight && fullHeight > window.innerHeight) {
        //       console.log('right stick');
        //       this.$refs.right.stick();
        //     } else {
        //       console.log('right unstick');
        //       this.$refs.right.unstick();
        //     }
        //   }
        // };

        window.addEventListener('resize', () => {
            this.sticky = window.innerWidth >= breakpoint;
            // fixStickyStuff();
        });
        // fixStickyStuff();
    },
    beforeRouteLeave(to, from, next) {
        if (to && from && to.path === from.path) {
            next();
        } else {
            if (this.sticky && this.$refs.left && this.$refs.right && this.$refs.scroll) {
                this.leave = true;
                setTimeout(() => {
                    window.scrollTo(0, 0);
                    next();
                }, 350);
            } else {
                next();
            }
        }
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
// @import "~@/assets/sass/variables"

section.slider,
section.banners
  padding: 0
section.heading
  padding-bottom: 0
</style>
